<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div
      class="modal fade"
      id="modal_form_remolque_export"
      style="background-color: #00000082"
    >
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h4 class="modal-title text-white">Generar listado Cisternas</h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              id="close-modal"
              ref="closeModal1"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body p-0">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="tab-Columnas"
                  data-toggle="tab"
                  href="#Columnas"
                  >Columnas</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="tab-Filtros"
                  data-toggle="tab"
                  href="#Filtros"
                  >Filtros
                </a>
              </li>
            </ul>
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane" id="Filtros">
                <div class="card-body">
                  <div class="form-group row">
                    <label for="placa" class="col-md-5">Placa</label>
                    <input
                      type="text"
                      id="placa"
                      v-model="filtros.placa"
                      class="form-control form-control-sm col-md-7"
                    />
                  </div>
                  <div class="form-group row">
                    <label for="empresa_id" class="col-md-5">Empresa</label>
                    <select
                      class="form-control form-control-sm col-md-7"
                      v-model="filtros.empresa_id"
                    >
                      <option value="">Seleccione...</option>
                      <option
                        v-for="empresa in listasForms.empresas"
                        :key="empresa.id"
                        :value="empresa.id"
                      >
                        {{ empresa.razon_social }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group row">
                    <label for="tipo_carroceria" class="col-md-5"
                      >Tipo de Carrocería</label
                    >
                    <select
                      class="form-control form-control-sm col-md-7"
                      v-model="filtros.tipo_carroceria"
                    >
                      <option value="">Seleccione...</option>
                      <option
                        v-for="tipo_carroceria in listasForms.tipos_carrocerias"
                        :key="tipo_carroceria.numeracion"
                        :value="tipo_carroceria.numeracion"
                      >
                        {{ tipo_carroceria.descripcion }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group row">
                    <label for="tipo_tapa" class="col-md-5">Tipo de Tapa</label>
                    <select
                      class="form-control form-control-sm col-md-7"
                      v-model="filtros.tipo_tapa"
                    >
                      <option value="">Seleccione...</option>
                      <option
                        v-for="tipo_tapa in listasForms.tipos_tapas"
                        :key="tipo_tapa.numeracion"
                        :value="tipo_tapa.numeracion"
                      >
                        {{ tipo_tapa.descripcion }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group row">
                    <label for="modelo" class="col-md-5"> Modelo</label>
                    <input
                      type="number"
                      id="Modelos"
                      v-model="filtros.modelo"
                      class="form-control form-control-sm col-md-7"
                    />
                  </div>
                  <div class="form-group row">
                    <label for="estado" class="col-md-5"> Estado</label>
                    <select
                      id="estado"
                      class="form-control form-control-sm col-md-7"
                      v-model="filtros.estado"
                    >
                      <option value="">Seleccione...</option>
                      <option
                        v-for="estado in listasForms.estados"
                        :key="estado.numeracion"
                        :value="estado.numeracion"
                      >
                        {{ estado.descripcion }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade active show" id="Columnas">
                <div class="card-body">
                  <div class="row">
                    <div class="col-lg-11">
                      <div class="form-group">
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="placa1"
                              v-model="form.placa"
                              class="custom-control-input"
                            />
                            <label class="custom-control-label" for="placa1"
                              >Placa</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="empresa_id"
                              v-model="form.empresa_id"
                              class="custom-control-input"
                            />
                            <label class="custom-control-label" for="empresa_id"
                              >Empresa</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="tipo_carroceria"
                              v-model="form.tipo_carroceria"
                              class="custom-control-input"
                            />
                            <label
                              class="custom-control-label"
                              for="tipo_carroceria"
                              >Tipo de Carrocería</label
                            >
                          </div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="tipo_tapa"
                              v-model="form.tipo_tapa"
                              class="custom-control-input"
                            />
                            <label class="custom-control-label" for="tipo_tapa"
                              >Tipo de Tapa</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="modelo"
                              v-model="form.modelo"
                              class="custom-control-input"
                            />
                            <label class="custom-control-label" for="modelo"
                              >Modelo</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="numero_ejes"
                              v-model="form.numero_ejes"
                              class="custom-control-input"
                            />
                            <label
                              class="custom-control-label"
                              for="numero_ejes"
                              >Número de ejes</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="ancho"
                              v-model="form.ancho"
                              class="custom-control-input"
                            />
                            <label class="custom-control-label" for="ancho"
                              >Ancho (metros)</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="largo"
                              v-model="form.largo"
                              class="custom-control-input"
                            />
                            <label class="custom-control-label" for="largo"
                              >Largo (metros)</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="alto"
                              v-model="form.alto"
                              class="custom-control-input"
                            />
                            <label class="custom-control-label" for="alto"
                              >Alto (metros)</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="peso_vacio"
                              v-model="form.peso_vacio"
                              class="custom-control-input"
                            />
                            <label class="custom-control-label" for="peso_vacio"
                              >Peso Vacío (kilogramos)</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="capacidad_galones"
                              v-model="form.capacidad_galones"
                              class="custom-control-input"
                            />
                            <label
                              class="custom-control-label"
                              for="capacidad_galones"
                              >Capacidad Galones</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="lista_documentos"
                              v-model="form.lista_documentos"
                              class="custom-control-input"
                            />
                            <label
                              class="custom-control-label"
                              for="lista_documentos"
                              >Lista de Documentos</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="fecha_creacion"
                              v-model="form.fecha_creacion"
                              class="custom-control-input"
                            />
                            <label
                              class="custom-control-label"
                              for="fecha_creacion"
                              >Fecha Creación</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="fecha_modificacion"
                              v-model="form.fecha_modificacion"
                              class="custom-control-input"
                            />
                            <label
                              class="custom-control-label"
                              for="fecha_modificacion"
                              >Fecha Modificación</label
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer justify-content-between">
            <div>
              <button
                type="button"
                class="btn btn-sm bg-navy"
                @click="generarListadoExcel()"
                v-if="$store.getters.can('argentina.trailers.export')"
              >
                Generar Listado
                <i class="fas fa-file-download"> </i>
              </button>
            </div>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "../../../../components/Loading";
//import vSelect from "vue-select";
export default {
  name: "RemolqueExport", //llegada tambien
  components: {
    Loading,
  },
  data() {
    return {
      cargando: false,
      form: {
        placa: true,
        empresa_id: true,
        tipo_carroceria: true,
        tipo_tapa: true,
        modelo: true,
        numero_ejes: true,
        ancho: true,
        largo: true,
        alto: true,
        peso_vacio: true,
        capacidad_galones: true,
        lista_documentos: true,
        fecha_creacion: true,
        fecha_modificacion: true,
      },
      filtros: {
        placa: null,
        empresa_id: null,
        tipo_carroceria: null,
        tipo_tapa: null,
        modelo: null,
        estado: null,
      },

      listasForms: {
        empresas: [],
        tipos_carrocerias: [],
        tipos_tapas: [],
        estados: [],
      },
    };
  },

  methods: {
    async getEmpresas() {
      // OBLIGATORIO: Cargar solo empresas con pais_id = 3
      await axios
        .get("/api/argentina/empresas/lista", {
          params: {
            pais_id: 3,
          },
        })
        .then((response) => {
          this.listasForms.empresas = response.data;
        });
    },

    async getTipoCarroceria() {
      await axios.get("/api/lista/9").then((response) => {
        this.listasForms.tipos_carrocerias = response.data;
      });
    },

    async getTipoTapa() {
      await axios.get("/api/lista/91").then((response) => {
        this.listasForms.tipos_tapas = response.data;
      });
    },

    getEstado() {
      axios.get("/api/lista/1").then((response) => {
        this.listasForms.estados = response.data;
      });
    },

    generarListadoExcel() {
      this.cargando = true;
      axios({
        method: "POST",
        url: "/api/argentina/trailers/export",
        data: { form: this.form, filtros: this.filtros },
      })
        .then((response) => {
          let data = response.data;
          this.cargando = false;
          location.href = data.url;
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrio un error" + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.cargando = false;
        });
    },
  },

  async mounted() {
    this.cargando = true;
    await this.getEmpresas();
    await this.getTipoCarroceria();
    await this.getTipoTapa();
    await this.getEstado();
    this.cargando = false;
  },
};
</script>
